import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = ['Home', 'Technology', 'Team']
const usecases = ['beauty-skincare', 'beauty-colorcosmetics', 'beauty-hair', 'food-superfoods', 'food-supplements', 'pharmacy' ]

const router = new VueRouter({
  base: process.env.BASE_URL,
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import('@/views/Home')
    },
    {
      path: '/use-cases/:usecase',
      name: 'UseCases',
      component: () => import('@/views/UseCase'),
    },
    {
      path: '/team',
      name: 'Team',
      component: () => import('@/views/Team')
    },
    {
      path: '/privacy-policy',
      name: 'PrivacyPolicy',
      meta: { isShortPage: true },
      component: () => import('@/views/PrivacyPolicy')
    },
    // {
    //   path: '/terms-and-conditions',
    //   name: 'TermsAndConditions',
    //   meta: { isShortPage: true },
    //   component: () => import('@/views/TermsAndConditions')
    // },
    {
      path:'/contact-us',
      name: 'ContactUs',
      meta: { isShortPage: true },
      component: () => import('@/views/ContactUs')
    }
  ],
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  if(!to.name && !routes.includes(to.name)) next({ path: '/' })
  else if (to.name === 'UseCases' && !usecases.includes(to.params.usecase)) next('/use-cases/beauty-skincare')
  else next()
})
export default router
